export const erc721BulkTransferAbi = [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [],
		"name": "InvalidArguments",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "InvalidCaller",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "InvalidContract",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "NotApproved",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "NotOwnerOfToken",
		"type": "error"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address[]",
				"name": "contractAddresses",
				"type": "address[]"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "totalAmount",
				"type": "uint256"
			}
		],
		"name": "BatchTransferToMultiple",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address[]",
				"name": "contractAddresses",
				"type": "address[]"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "totalAmount",
				"type": "uint256"
			}
		],
		"name": "BatchTransferToSingle",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC721[]",
				"name": "erc721Contracts",
				"type": "address[]"
			},
			{
				"internalType": "address[]",
				"name": "tos",
				"type": "address[]"
			},
			{
				"internalType": "uint256[][]",
				"name": "tokenIds",
				"type": "uint256[][]"
			}
		],
		"name": "batchTransferToMultipleWallets",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC721[]",
				"name": "erc721Contracts",
				"type": "address[]"
			},
			{
				"internalType": "address[][]",
				"name": "recipients",
				"type": "address[][]"
			},
			{
				"internalType": "uint256[][]",
				"name": "tokenIds",
				"type": "uint256[][]"
			}
		],
		"name": "batchTransferToMultipleWalletsStructured",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC721[]",
				"name": "erc721Contracts",
				"type": "address[]"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256[][]",
				"name": "tokenIds",
				"type": "uint256[][]"
			}
		],
		"name": "batchTransferToSingleWallet",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC721[]",
				"name": "erc721Contracts",
				"type": "address[]"
			},
			{
				"internalType": "address[]",
				"name": "tos",
				"type": "address[]"
			},
			{
				"internalType": "uint256[][]",
				"name": "tokenIds",
				"type": "uint256[][]"
			}
		],
		"name": "safeBatchTransferToMultipleWallets",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC721[]",
				"name": "erc721Contracts",
				"type": "address[]"
			},
			{
				"internalType": "address[][]",
				"name": "recipients",
				"type": "address[][]"
			},
			{
				"internalType": "uint256[][]",
				"name": "tokenIds",
				"type": "uint256[][]"
			}
		],
		"name": "safeBatchTransferToMultipleWalletsStructured",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC721[]",
				"name": "erc721Contracts",
				"type": "address[]"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256[][]",
				"name": "tokenIds",
				"type": "uint256[][]"
			}
		],
		"name": "safeBatchTransferToSingleWallet",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
] as const;